const PetroprixLogo = ({
  color = "#db0b27",
  size, // tamaño base (ancho). Altura se calcula manteniendo proporción.
  width,
  height,
  ...props
}) => {
  // Proporción original del viewBox (ancho: 194, alto: 43)
  const aspectRatio = 43 / 194;

  const finalWidth = width ?? (size ? size : 194);
  const finalHeight = height ?? (size ? size * aspectRatio : 43);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 194 43"
      width={finalWidth}
      height={finalHeight}
      {...props}
    >
      <path
        fill={color}
        d="M24.03 12.43c0 6.12-4.93 11.05-11.29 11.05H7.91V33.6H.56V1.36h12.18a11.1 11.1 0 0 1 11.29 11.07Zm-7.37 0c0-2.35-1.66-4.15-3.92-4.15H7.91v8.3h4.83c2.26 0 3.92-1.79 3.92-4.15ZM37.8 28.09a6.02 6.02 0 0 0 4.42-1.75l5.51 3.17c-2.25 3.14-5.66 4.75-10.04 4.75-7.87 0-12.75-5.3-12.75-12.16 0-6.85 4.97-12.16 12.25-12.16 6.72 0 11.7 5.2 11.7 12.16 0 .93-.09 1.85-.28 2.76H32.28c.87 2.4 2.98 3.23 5.52 3.23Zm4.22-8.4c-.74-2.67-2.81-3.63-4.9-3.63-2.63 0-4.38 1.29-5.02 3.63h9.92ZM60.87 17.22v8.16c0 1.98 1.7 2.17 4.74 1.98v6.25c-9.02.92-11.65-1.8-11.65-8.24V17.2H50.3v-6.62h3.67V6.22l6.91-2.07v6.43h4.74v6.64h-4.74ZM83.8 10.12v7.83c-2.85-.46-6.9.7-6.9 5.25v10.41h-6.91V10.58h6.9v4.09c.93-3.07 4.01-4.55 6.92-4.55ZM85.64 22.1a12.2 12.2 0 1 1 12.2 12.16 12.08 12.08 0 0 1-12.2-12.16Zm17.5 0c0-3.27-2.3-5.44-5.3-5.44-3.01 0-5.31 2.17-5.31 5.44 0 3.27 2.3 5.43 5.3 5.43 3.01 0 5.31-2.16 5.31-5.43ZM138.29 22.1c0 6.86-4.97 12.16-11.03 12.16-3.08 0-5.34-1.06-6.86-2.81v11.38h-6.89V10.57h6.9v2.18c1.53-1.75 3.78-2.8 6.87-2.8 6.03-.01 11 5.29 11 12.15Zm-6.91 0c0-3.46-2.3-5.62-5.48-5.62-3.18 0-5.48 2.16-5.48 5.62 0 3.45 2.3 5.62 5.48 5.62 3.18 0 5.48-2.17 5.48-5.62ZM156.02 10.58v7.83c-2.86-.46-6.91.7-6.91 5.25v9.95h-6.9V10.58h6.9v4.56c.92-3.08 4-4.56 6.9-4.56ZM158.55 4.41a4.15 4.15 0 1 1 8.3.26 4.15 4.15 0 0 1-8.3-.26Zm.7 6.17h6.9v23.03h-6.9V10.58ZM185.17 33.61l-4.28-6.08-4.28 6.08h-7.93l8.25-11.7-7.97-11.33h7.92l4 5.72 4.01-5.72h7.93l-7.97 11.34 8.25 11.7h-7.93Z"
      />
    </svg>
  );
};

export default PetroprixLogo;
